module.exports = __webpack_public_path__ + "static/media/subOutlook1.01a36ddf.png";